import React, { Component } from "react";
import pointingBlackOutline from "../../assets/images/pointing-right-stretched-black-outline.svg";
import pointingWhiteOutline from "../../assets/images/pointing-right-stretched-white-outline.svg";
import pointingFilled from "../../assets/images/pointing-right-stretched-fill.svg";
import { Link } from "react-router-dom";
import "../../styles/nextprompt/NextPromptButton.css";

export default class NextPromptButton extends Component {
  render() {
    return (
      <div className="NextPromptButton button-container">
        <Link className="g-button white" to={this.props.link}>
          {this.props.text}
        </Link>
        <div className="pointing-container">
          <img
            className="white-outline"
            src={pointingWhiteOutline}
            alt="pointing finger"
          />
          <img
            className="fill"
            src={pointingFilled}
            alt="pointing finger filled"
          />
          <img
            className="black-outline"
            src={pointingBlackOutline}
            alt="pointing finger"
          />
        </div>
      </div>
    );
  }
}
